export default __webpack_public_path__ + "static/media/facebook-in-stream-videos.915e13d2.jpg";